<template>
  <div>
    <section>
      <b-col class="d-flex justify-content-between px-0 pt-25">
        <b-button
          v-b-modal.modal-add-user
          variant="primary"
          :disabled="isLoading"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Account.Edit.AddUser') }}
        </b-button>
        <b-row class="mr-0">
          <selected-filter
            v-if="selectedFilters.selectedFilter.length"
            :text="selectedFilters.name"
            :number="selectedFilters.selectedFilter.length.toString()"
            class="mr-1"
            @click="toggleFilters(true)"
            @clearFilter="clearFilters"
          />
          <dropdown
            :title="$tk('ClientPortal.MasterTable.Filters')"
            class="mb-1"
            :disabled="isLoading"
            :show-dropdown="showFilters"
            @change="toggleFilters"
          >
            <template #menu-items>
              <dropdown-item
                v-for="(role, roleIndex) in model.roleInfos"
                :key="role.text + '-' + roleIndex"
                :label="role.text"
                :value="role.value"
                :selected="role.selected"
                @change="includeOrExclude"
              />
              <dropdown-clear-item
                :title="$tk('ClientPortal.Filters.ClearAll')"
                @click="clearFilters"
              />
            </template>
          </dropdown>
          <!-- <SearchInputField
            @onInputSearch="onSearchChange"
          /> -->
        </b-row>
      </b-col>
      <b-card
        class="my-50 admin-table--management"
        no-body
      >
        <Table
          :data="allUsers"
          :columns="usersColumns"
          :is-loading="isLoading"
          remote-mode
          class="admin-table__data users-table"
          type-of-table="users"
          @changePage="changeCurrentPage"
          @onSortChange="sort"
        />
        <!-- Delete User Modal -->
        <b-modal
          id="modal-small-delete"
          :ok-title="$tk('ClientPortal.Form.Actions.Delete')"
          :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
          ok-variant="danger"
          cancel-variant="outline-secondary"
          centered
          size="md"
          :title="$tk('ClientPortal.Admin.DeleteUser')"
          no-enforce-focus
          @ok="triggerDelete"
        >
          <span>{{ $tk('ClientPortal.Admin.AreYouSureYouWantToDeleteThisUser') }}</span>
        </b-modal>
        <!-- Add/Edit user modal -->
        <b-modal
          id="modal-add-user"
          :title="userModel.id > 0 ? $tk('ClientPortal.Account.Edit.EditUser') : $tk('ClientPortal.Account.Edit.AddNewUser')"
          :ok-title="$tk('ClientPortal.Form.Actions.Save')"
          :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
          centered
          cancel-variant="outline-secondary"
          no-enforce-focus
          :ok-disabled="saving || !isFormComplete()"
          @show="getUserModel"
          @ok="triggerAdminUser"
        >
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Account.Edit.Email') + ' *'"
            :invalid-feedback="errors['Email']"
          >
            <b-form-input
              v-model="userModel.email"
              type="email"
              placeholder="example@email.com"
              :disabled="userModel.id > 0"
              :state="errors['Email'] == null ? null : false"
            />
          </b-form-group>
          <b-form-group
            :label="$tk('ClientPortal.Account.Edit.Role') + ' *'"
            class="mb-0"
          >
            <div
              v-for="role in userRoles"
              :key="role.id"
            >
              <b-form-radio
                v-model.number="userModel.roleId"
                class="mb-1"
                :value="role.id"
              >
                <div class="text-dark">
                  {{ role.role }}
                </div>
                <span class="text-secondary ">
                  <small class="text-muted text-xsm">{{ role.description }}</small>
                </span>
              </b-form-radio>
            </div>
          </b-form-group>
        </b-modal>
      </b-card>
    </section>
  </div>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  computed,
  onMounted,
  ref,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Table from '@/components/Table.vue'
// import SearchInputField from '@/components/SearchInputField.vue'
import AccountAdminService from '@/api/admin/accountAdmin.service'
import notification from '@/mixins/toastification'
import store from '@/store'
import DropdownClearItem from '@/components/DropdownClearItem.vue'
import SelectedFilter from '@/components/SelectedFilter.vue'
import DropdownItem from '@/components/DropdownItem.vue'
import Dropdown from '@/components/Dropdown.vue'
import translation from '@/mixins/translate'
import onSortChange from '@/mixins/onSortChange'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    // SearchInputField,
    GjIcon,
    Table,
    Dropdown,
    DropdownItem,
    SelectedFilter,
    DropdownClearItem,
  },
  mixins: [notification],
  setup() {
    const usersColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.User.Id'),
        field: 'id',
        type: 'number',
        width: '100px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.User.Email'),
        field: 'email',
        type: 'email',
        width: '370px !important',
        sortable: false,
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.User.Role'),
        field: 'role',
        width: '270px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.User.CreatedAt'),
        field: 'createdAt',
        width: '250px !important',
      },
    ]
    const allUsers = computed(() => store.getters.allUsers)
    const isLoading = ref(false)
    const saving = ref(false)
    const errors = ref({})
    const userModel = ref({})
    const userRoles = computed(() => store.getters.userRoles)
    const model = computed(() => store.getters.getUsersModel)
    const showFilters = ref(false)
    const selectedFilters = ref({ name: 'Roles', selectedFilter: [] })

    const changeCurrentPage = async value => {
      model.value.serverParams.page = value
      await store.dispatch('getFilteredUsers', model.value)
    }

    const sort = value => {
      onSortChange(value, model, 'getFilteredUsers')
    }

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getUsers')
      isLoading.value = false
    })

    const isFormComplete = () => {
      const { email, roleId } = userModel.value
      return email && roleId
    }

    const onFilterChange = async () => {
      await store.dispatch('getFilteredUsers', model.value)
    }

    const getUserModel = () => {
      userModel.value = store.getters.getUserModel
      errors.value = {}
      store.commit('SET_USER_MODEL', {})
    }

    const triggerDelete = async () => {
      const deleteData = store.getters.rowToDelete
      try {
        const response = await AccountAdminService.deleteUser(deleteData)

        if (response.saved) {
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getFilteredUsers', model.value)
      }
    }
    const rowAnimation = () => {
      const newRow = Array.from(document.querySelectorAll('.users-table > .vgt-wrap > .vgt-inner-wrap > .vgt-responsive > table > tbody > tr:first-child')).pop()
      newRow.classList.remove('table-row-animation')
      // eslint-disable-next-line no-unused-expressions
      newRow.offsetHeight // trigger reflow
      newRow.classList.add('table-row-animation')
    }
    const triggerAdminUser = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      let response = null
      try {
        if (userModel.value.id > 0) {
          response = await AccountAdminService.updatePlatformUser(userModel.value)
        } else { response = await AccountAdminService.createPlatformUser(userModel.value) }
        if (response.saved) {
          bvModalEvt.vueTarget.hide('modal-add-user')
          notification.methods.success(response.message)
          rowAnimation()
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getFilteredUsers', model.value)
        saving.value = false
      }
    }

    const includeOrExclude = (filter, option) => {
      const selectedRole = model.value.roleInfos.find(x => x.value === option)
      selectedRole.selected = !selectedRole.selected
      selectedFilters.value.selectedFilter = model.value.roleInfos.filter(x => x.selected)
      model.value.serverParams.roles = selectedFilters.value.selectedFilter.map(x => x.value)
      onFilterChange()
    }

    const toggleFilters = (toogleFilter = null) => {
      showFilters.value = toogleFilter ?? !showFilters.value
    }

    const clearFilters = () => {
      selectedFilters.value.selectedFilter = []
      model.value.serverParams.roles = null
      model.value.roleInfos.forEach(role => {
        role.selected = false
      })
      toggleFilters(false)
      onFilterChange()
    }

    //  This is commented because search is going to be implemented later
    // const onSearchChange = async value => {
    //   model.value.serverParams.email = value
    // if (!value) {
    //    await store.dispatch('getFilteredUsers', model.value)
    //   }
    //     await store.dispatch('getFilteredUsers', model.value)
    // }

    window.onclick = e => {
      if (!e.path.find(x => x.className?.includes('dropdown'))) {
        toggleFilters(false)
      }
    }

    return {
      allUsers,
      isLoading,
      changeCurrentPage,
      triggerDelete,
      userModel,
      getUserModel,
      triggerAdminUser,
      isFormComplete,
      userRoles,
      saving,
      errors,
      onFilterChange,
      model,
      showFilters,
      selectedFilters,
      includeOrExclude,
      clearFilters,
      toggleFilters,
      usersColumns,
      // onSearchChange,
      sort,
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/views/added_row_animation.scss';
</style>
